import axios from 'axios'
// import { store } from '../vuex-storage/globalStoreParameters'
import { userService } from '../../components/Auth/_services/'
// import { store } from '../../backend/vuex-storage/globalStoreParameters'
// const API_URL = process.env.API_URL || 'http://localhost:8080/Aml.WcfServices.AmlService.svc'
// const API_URL = process.env.API_URL || 'https://service.screeninghub.ge/Aml.WcfServices.AmlService.svc'
// const API_URL = process.env.API_URL || 'https://service.screeninghub.ge/AmlService.svc'

// This is testing service
// const API_URL = process.env.API_URL || 'http://midapi_test.screeninghub.ge'
// THIS IS PROD
// const API_URL = process.env.API_URL || 'https://baseapi.screeninghub.ge'
// const API_URL = process.env.API_URL || 'http://baseapidev.screeninghub.ge'
// const API_URL = process.env.API_URL || 'https://localhost:44334'
const API_URL = process.env.API_URL || 'https://baseapiprod.screeninghub.ge'

// axios.interceptors.response.use((response) => {
//   // debugger // eslint-disable-line
//   // Return normal response
//   return response
// }, (error) => {
//   // Return non auth error
//   if (error.response.status !== 401) {
//     return new Promise((resolve, reject) => {
//       reject(error)
//     })
//   }

//   return userService.refreshToken()
//     .then((token) => {
//       console.log(token)
//       // Make new request
//       const config = error.config
//       config.headers = { Authorization: `Bearer ${store.getters.getAccessToken}` }

//       return new Promise((resolve, reject) => {
//         axios.request(config).then(response => {
//           resolve(response)
//         }).catch((error) => {
//           reject(error)
//         })
//       })
//     })
//     .catch((error) => {
//       Promise.reject(error)
//     })
// })
// const isRefreshing = false
axios.interceptors.response.use(function (response) {
  return response
}, (err) => {
  if (err.response.status === 401) {
    userService.refreshToken()
  } else {
    console.log(err)
  }
})

// axios.interceptors.request.use((config) => {
//   const token = store.getters.getAccessToken
//   if (token) {
//     config.headers['x-access-token'] = token
//   }
// })

export default {
  Login (data) {
    return axios.post(API_URL + '/api/Auth/Authorize', data)
  },
  RefreshJWTToken (data) {
    return axios.post(API_URL + '/api/Auth/RefreshToken', data)
  },
  GetPreparationData (RequestGeneralData) {
    return axios.get(API_URL + '/api/PreparationData/GetPreparationData', RequestGeneralData)
  },
  GetSearchesInfo (header) {
    return axios.get(API_URL + '/api/AcurisClick/GetAcurisClickByOrganization', header)
  },
  AddRequest (data) {
    return axios.post(API_URL + '/rest/AddRequest', data)
  },
  AddRequestWithDetails (header, data) {
    return axios.post(API_URL + '/api/Request/AddRequestWithDetail', data, header)
  },
  AddRequestWithDetailsv2 (header, data) {
    data.countryISO = data.countryISOstr
    data.city = data.citystr
    return axios.post(API_URL + '/api/Request/AddRequestWithDetail01', data, header)
  },
  GetUsers (data) {
    return axios.post(API_URL + '/rest/GetUsers', data)
  },
  GetRequests (data) {
    return axios.get(API_URL + '/api/Request/GetRequests', data)
  },
  GetRequestsServerSide (header, data) {
    return axios.post(API_URL + '/api/Request/GetRequestsForPaging', data, header)
  },
  GetMatchesByRequestId (data, id) {
    return axios.get(API_URL + '/api/AcurisRisk/GetAcurisRiskByRequestId/' + id, data)
  },
  LoadIndividualDetails (header, id) {
    return axios.get(API_URL + '/api/AcurisApi/GetPersonDetails/GetPersonDetails/' + id, header)
  },
  LoadBusinessDetails (header, id) {
    return axios.get(API_URL + '/api/AcurisApi/GetBusinessDetails/GetBusinessDetails/' + id, header)
  },
  GetRequestWithDetail (data, id) {
    return axios.get(API_URL + '/api/Request/GetRequestWithDetail/' + id, data)
  },
  SetRequestStatus (data, Id, statusId) {
    // const test = {
    //   id: Id,
    //   status: statusId
    // }
    // debugger // eslint-disable-line
    return axios.put(API_URL + '/api/Request/EditRequestStatus/' + Id + '?statusId=' + statusId, '', { headers: { accept: 'text/plain', Authorization: data.headers.Authorization } })
  },
  GetRequestByID (header, id) {
    return axios.get(API_URL + '/api/Request/GetRequest/' + id, header)
  },
  GetRequestsWithMatches (data) {
    return axios.get(API_URL + '/api/Request/GetRequestsWithMatches', data)
  },
  GetScanResultByRequestId (data) {
    return axios.post(API_URL + '/rest/GetNameScanResultByRequestId', data)
  },
  GetNameScanPeopleByRequestId (data) {
    return axios.post(API_URL + '/rest/GetNameScanPeopleByRequestId', data)
  },
  GetPersonDetailsByPersonId (data) {
    return axios.post(API_URL + '/rest/GetPersonDetailsByPersonId', data)
  },
  GetPersonWithDetails (data) {
    return axios.post(API_URL + '/rest/GetPersonWithDetails', data)
  },
  GetBlackList (data) {
    return axios.get(API_URL + '/api/BlackList/GetBlackLists', data)
  },
  UpdateBlackList (data) {
    return axios.post(API_URL + '/rest/UpdateBlackList', data)
  },
  AddBlackListRecord (header, data) {
    return axios.post(API_URL + '/api/BlackList/AddBlackList', data, header)
  },
  GetWhiteList (data) {
    return axios.get(API_URL + '/api/WhiteList/GetWhiteLists', data)
  },
  ChangeWhiteListStatus (data, Id, statusId) {
    const test = {
      id: Id,
      status: statusId
    }
    return axios.put(API_URL + '/api/WhiteList/EditWhiteListStatus/' + Id + '?status=' + statusId, test, { headers: { accept: 'text/plain', Authorization: data.headers.Authorization } })
  },
  ChangeBlackListStatus (data, Id, statusId, comment) {
    const test = {
      id: Id,
      status: statusId,
      comment: comment
    }
    return axios.put(API_URL + '/api/BlackList/EditBlackListStatus/' + Id + '?status=' + statusId + '&comment=' + comment, test, { headers: { accept: 'text/plain', Authorization: data.headers.Authorization } })
  },
  AddWhiteListRecord (header, data) {
    return axios.post(API_URL + '/api/WhiteList/AddWhiteList', data, header)
  },
  GetNotifications (data) {
    return axios.get(API_URL + '/api/Notification/GetNotificationsByUserId', data)
  },
  markNtfAsRead (data, HeaderParams) {
    // console.log(data)
    // console.log(HeaderParams)
    // return axios.put(API_URL + '/api/Notification/EditNotification/' + data.id, { data: data }, { headers: { accept: 'text/plain', Authorization: HeaderParams.headers.Authorization } })
    return axios({
      method: 'put',
      url: API_URL + '/api/Notification/EditNotification/' + data.id,
      headers: {
        accept: 'text/plain',
        Authorization: HeaderParams.headers.Authorization
      },
      data: data
    })
  },
  GetUNEntitiesDiff (header) {
    return axios.get(API_URL + '/api/UnEntitiesDiff/GetUnEntitiesDiffDetailsWithDates/', header)
  },
  GetUNIndividualsDiff (header) {
    return axios.get(API_URL + '/api/UnIndividualsDiff/GetUnIndividualsDiffDetailsWithDates/', header)
  },
  // COMMENTS
  GetCommentsByRequestId (header, id) {
    return axios.get(API_URL + '/api/Comment/GetCommentsByRequestId/' + id, header)
  },
  AddComment (header, data) {
    return axios.post(API_URL + '/api/Comment/AddComment', data, header)
  },
  // CLIENTS SERVICES
  GetAmlClientsWithRelatedPersons (header) {
    return axios.get(API_URL + '/api/AmlClient/GetAmlClients', header)
  },
  GetClientRequests (header) {
    return axios.get(API_URL + '/api/Request/GetRequestsForClients', header)
  },
  GetClientsServerSide (header, params) {
    return axios.post(API_URL + '/api/AmlClient/GetAmlClientsForPaging', params, header)
  },
  AddAmlClients (header, data) {
    data.addressCountryISO = data.addressCountry
    return axios.post(API_URL + '/api/AmlClient/AddAmlClients', data, header)
  },
  AddAmlClientsRelations (header, data) {
    return axios.post(API_URL + '/api/AmlClient/AddAmlClientRelations', data, header)
  },

  // USERS SERVICES
  GetSystemUsers (header) {
    return axios.get(API_URL + '/api/AmlUser/GetUsers', header)
  },
  ValidateUsername (header, username) {
    return axios.get(API_URL + '/api/AmlUser/ValidateUserName/' + username, header)
  },
  AddUser (header, data) {
    return axios.post(API_URL + '/api/AmlUser/AddUser', data, header)
  },
  EditUser (header, data) {
    return axios.put(API_URL + '/api/AmlUser/EditUser/' + data.id, data, { headers: { accept: 'text/plain', Authorization: header.headers.Authorization } })
  },
  ChangePassword (header, data) {
    return axios.get(API_URL + '/api/AmlUser/ChangeUserPassword/' + data.password + '?userId=' + data.id, header)
  },
  // SETTINGS SERVICE
  GetCurrentSettings (header) {
    return axios.get(API_URL + '/api/AmlSetting/GetAmlSettings', header)
  },
  // PARAMETERS SERICES
  GetAMLParameters (header) {
    return axios.get(API_URL + '/api/AmlParameter/GetAmlParametersByOrganisationId', header)
  },
  AddAMLParameter (header, data) {
    return axios.post(API_URL + '/api/AmlParameter/AddAmlParameter', data, header)
  },
  EditAMLParameter (header, data) {
    return axios.put(API_URL + '/api/AmlParameter/EditAmlParameter/' + data.amlParameter.id, data, { headers: { accept: 'text/plain', Authorization: header.headers.Authorization } })
  },
  AddDecisionResults (header, data) {
    return axios.post(API_URL + '/api/DecisionResult/AddDecisionResults', data, header)
  },

  // updates new methods
  // individuals
  GetIndividualUpdateDetailsDatesUN (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsDatesUN', header)
  },
  GetIndividualUpdateDetailsDatesOFAC (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsDatesOFAC', header)
  },
  GetIndividualUpdateDetailsDatesUK (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsDatesUK', header)
  },
  GetIndividualUpdateDetailsDatesEU (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsDatesEU', header)
  },
  GetIndividualUpdateDetailsByDateUN (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsByDateUN/' + date, header)
  },
  GetIndividualUpdateDetailsByDateOFAC (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsByDateOFAC/' + date, header)
  },
  GetIndividualUpdateDetailsByDateUK (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsByDateUK/' + date, header)
  },
  GetIndividualUpdateDetailsByDateEU (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetIndividualUpdateDetailsByDateEU/' + date, header)
  },

  GetCompanyUpdateDetailsDatesUN (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsDatesUN', header)
  },
  GetCompanyUpdateDetailsDatesOFAC (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsDatesOFAC', header)
  },
  GetCompanyUpdateDetailsDatesEU (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsDatesEU', header)
  },
  GetCompanyUpdateDetailsDatesUK (header) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsDatesUK', header)
  },

  GetCompanyUpdateDetailsByDateUN (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsByDateUN/' + date, header)
  },
  GetCompanyUpdateDetailsByDateOFAC (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsByDateOFAC/' + date, header)
  },
  GetCompanyUpdateDetailsByDateUK (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsByDateUK/' + date, header)
  },
  GetCompanyUpdateDetailsByDateEU (header, date) {
    return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsByDateEU/' + date, header)
  },
  // /api/AcurisLocal/GetCompanyUpdateDetailsByDateUN
  // GetCompanyUpdateDetailsDatesUN (header) {
  //   return axios.get(API_URL + '/api/AcurisLocal/GetCompanyUpdateDetailsDatesUN', header)
  // }

  GetPersonEvidences33 (header, resouceid, evidenceid) {
    return axios.get(API_URL + '/api/AcurisApi/GetPersonEvidences/GetPersonEvidences/' + resouceid + '/' + evidenceid, header)
  },
  GetPersonEvidences (header, resouceid, evidenceid) {
    return axios.get(
      `${API_URL}/api/AcurisApi/GetPersonEvidences/GetPersonEvidences/${resouceid}/${evidenceid}`,
      {
        headers: header.headers,
        responseType: 'blob' // Ensure this is correctly set
      }
    )
  },
  GetPersonEvidences2 (header, resouceid, evidenceid) {
    axios({
      url: API_URL + '/api/AcurisApi/GetPersonEvidences/GetPersonEvidences/' + resouceid + '/' + evidenceid, // Replace with your actual API endpoint
      method: 'GET',
      responseType: 'blob' // Important: This tells axios to treat the response as a Blob
    })
  },
  GetPersonEvidencesString (header, resouceid, evidenceid) {
    return axios.get(API_URL + '/api/AcurisApi/GetPersonEvidencesString/GetPersonEvidencesString/' + resouceid + '/' + evidenceid, header, { responseType: 'application/pdf', 'Accept-Ranges': 'bytes' })
  },
  GetBusinessEvidences (header, resouceid, evidenceid) {
    return axios.get(API_URL + '/api/AcurisApi/GetBusinessEvidences/GetBusinessEvidences/' + resouceid + '/' + evidenceid, header)
  }
}
